var controller = new ScrollMagic.Controller();

$(function () {

  var scene = new ScrollMagic.Scene({triggerElement: ".js-trigger-fixed-nav", duration: $('.js-trigger-fixed-nav').height()})
    .setPin(".js-fixed-nav")
    .offset($('.js-fixed-nav').outerHeight() + 20)
    .addTo(controller);


  $('.js-open-mobile-menu').on('click', function (e) {
    $('.js-mobile-menu').addClass('visible');

    e.preventDefault();
  });

  $('.js-close-mobile-menu').on('click', function (e) {
    $('.js-mobile-menu').removeClass('visible');

    e.preventDefault();
  });


  // Begin: Geolizr Override
  $('<div class="container absolute m-auto t0 l0 r0"><div class="container-geolizr absolute t4 l0"></div></div>').insertBefore('header.main-nav div.absolute');
  $('<div class="container-geolizr"></div>').prependTo('.main-footer');
  $('.absolute .container-geolizr').prepend($('.geolizr-currency-switch-wrapper'));
  $('.main-footer .container-geolizr').prepend($('.geolizr-currency-switch-wrapper').clone().addClass('mobile-show'));
/*  
  var selected = $('.select-selected').text();
  $('.select-selected').empty();
  var $selected = $('.select-selected').text(selected.split(' - ')[0] + ' - ').append($('#price-preview .geolizr-currency').clone());
  
  $('.select-items div').each(function(){
    var originalText = $(this).text();
    var size = originalText.split(' - ')[0];
    var price = originalText.split('$')[1];
    var price2 = originalText.split('$')[1] * 100;
    var $span = $('<span class="geolizr-currency" data-geolizr-price="' + price2 + '">$' + price + '</span>');
    $(this).text(size + ' - ').append($span);
  });
  
  $('select[name="id"] option').each(function(){
    var originalText = $(this).text();
    var size = originalText.split(' - ')[0];
    var price = originalText.split('$')[1];
    var price2 = originalText.split('$')[1] * 100;
    var $span = $('<span class="geolizr-currency" data-geolizr-price="' + price2 + '">$' + price + '</span>');
    $(this).text(size + ' - ').append($span);
  });
  // End: Geolizr Override
*/
  
});
